import { useEffect, useState } from 'react';

type BreathingBoxProps = {
  labels: {
    intro: string;
    inhale: string;
    hold: string;
    exhale: string;
  };
};

const PHASE_MS = 4000;
type BreathingPhase = 'hold_small' | 'inhale' | 'hold_large' | 'exhale';
const PHASES: BreathingPhase[] = ['hold_small', 'inhale', 'hold_large', 'exhale'];

export function BreathingBox({ labels }: BreathingBoxProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(id);
  }, []);

  const phaseIndex = Math.floor((now % (PHASE_MS * PHASES.length)) / PHASE_MS);
  const phase = PHASES[phaseIndex] ?? 'hold_small';
  const phaseElapsed = now % PHASE_MS;
  const phaseProgress = phaseElapsed / PHASE_MS;
  const phaseLabel = phase === 'inhale' ? labels.inhale : phase === 'exhale' ? labels.exhale : labels.hold;

  return (
    <div className="breathing-box-card" aria-live="polite">
      <div className={`breathing-box breathing-${phase}`} style={{ ['--breathe-progress' as string]: String(phaseProgress) }} />
      <div className="small breathing-box-intro">{labels.intro}</div>
      <div className="row-title breathing-box-phase">{phaseLabel}</div>
    </div>
  );
}
